import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../app/consts";

export class DisclaimerImageRequestParams extends AssetsRequestParams {
  constructor(color) {
    super();

    this.resourceName = this.resourceName + '/Disclaimer_over_18/disclaimer_white-01'
    this.color = color;
    this.ratio = 3;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}
